import { IApplicationFrontEndModel } from "../../types";
import { calculateIntakeName } from "../../../../helpers";
import { EducationType } from "../../../school/constants/types";

export function parseToFrontEndModel({
  programId,
  program,
  students,
  educationType,
  studentId,
}): IApplicationFrontEndModel {
  const isHigherOrSecondary =
    educationType === EducationType.Higher ||
    educationType === EducationType.Secondary;

  return {
    injectedData: {
      programId,
      educationType,
      students,
      program: {
        ...(isHigherOrSecondary
          ? {
              branches: program.branches,
              intakes: program.intakes,
              ...program.academic,
            }
          : program),
        ...(isHigherOrSecondary && {
          intakes: program.intakes.map((item) => ({
            name: `${item.startDate} ${calculateIntakeName(item?.startDate)}`,
            id: item.id,
          })),
        }),
        restrictedCountries: program.restrictedCountries,
      },
      isStudent: !!studentId,
    },
    step1: {
      branch: null,
      student: studentId
        ? { id: studentId, studentProfile: { country: "" } }
        : null,
      intake: null,
    },
  };
}
